export default __webpack_public_path__ + "static/media/linkedin-extension.a6c6a716.png";